import React from "react";

const STEP_NAMES = [
  "Basic Information",
  "Eligibility",
  "Health",
  "Insurance",
  "Certifications",
  "Review",
];

export function StepProgress({
  currentStep,
  onJump,
  completion,
}: {
  currentStep: number;
  onJump?: (s: number) => void;
  // Per-section completeness for Steps 1–5 (Step 6 Review has no indicator).
  // Navigation is never blocked; this badge is purely informational.
  completion?: Record<number, boolean>;
}) {
  return (
    <nav aria-label="Application steps" className="mb-6">
      <ol className="flex flex-wrap gap-2 text-xs sm:text-sm">
        {STEP_NAMES.map((name, i) => {
          const stepNo = i + 1;
          const active = stepNo === currentStep;
          const past = stepNo < currentStep;
          const hasIndicator = completion != null && stepNo <= 5;
          const complete = hasIndicator ? completion![stepNo] === true : false;
          return (
            <li key={name} className="flex-1 min-w-[100px]">
              <button
                type="button"
                onClick={() => onJump?.(stepNo)}
                disabled={!onJump}
                className={`w-full text-left rounded-md border px-3 py-2 transition ${
                  active
                    ? "border-program bg-program text-white font-medium"
                    : past
                    ? "border-program/40 bg-program/10 text-program"
                    : "border-slate-200 bg-white text-slate-500"
                } ${onJump ? "cursor-pointer hover:border-program" : "cursor-default"}`}
              >
                <span className="block text-[10px] uppercase tracking-wide opacity-70">Step {stepNo}</span>
                <span className="block">{name}</span>
                {hasIndicator && (
                  <span
                    className={`mt-1 block text-[10px] font-medium ${
                      active
                        ? "text-white/90"
                        : complete
                        ? "text-green-600"
                        : "text-amber-600"
                    }`}
                  >
                    {complete ? "✓ Complete" : "• Incomplete"}
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
